import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material'
import TableEmptyState from '../shared/TableEmptyState'
import TableLoadingRow from '../shared/TableLoadingRow'
import { formatOrderDate } from './formatOrderDate'
import { COLUMN_COUNT, ROWS_PER_PAGE_OPTIONS } from './constants'

export default function NegativeSalesReportTable({
  rows,
  loading,
  page,
  rowsPerPage,
  total,
  onPageChange,
  onRowsPerPageChange,
}) {
  return (
    <Paper>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date Created</TableCell>
              <TableCell>Shop</TableCell>
              <TableCell>Shop Id</TableCell>
              <TableCell>Invoice No.</TableCell>
              <TableCell>Article code</TableCell>
              <TableCell>Product Name</TableCell>
              <TableCell>Preferred Source</TableCell>
              <TableCell align="right">Quantity</TableCell>
              <TableCell align="right">MRP</TableCell>
              <TableCell align="right">Total Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableLoadingRow colSpan={COLUMN_COUNT} />
            ) : rows.length === 0 ? (
              <TableEmptyState
                colSpan={COLUMN_COUNT}
                message="No Negative Sales in range."
              />
            ) : (
              rows.map((r) => (
                <TableRow key={r.line_item_id}>
                  <TableCell>{formatOrderDate(r.order_date)}</TableCell>
                  <TableCell>{r.organization_name}</TableCell>
                  <TableCell>{r.org_id ?? '—'}</TableCell>
                  <TableCell>{r.order_id ?? '—'}</TableCell>
                  <TableCell>{r.sku ?? '—'}</TableCell>
                  <TableCell>{r.product_name ?? '—'}</TableCell>
                  <TableCell>{r.preferred_source ?? '—'}</TableCell>
                  <TableCell align="right">{r.quantity}</TableCell>
                  <TableCell align="right">{r.unit_price}</TableCell>
                  <TableCell align="right">{r.total_price}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      />
    </Paper>
  )
}
